import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";
import { CustomerDashboardService } from "../../../services/customer-dashboard.service";
import { StorageService } from "src/app/services/storage.service";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "fury-complaint-modal",
  templateUrl: "./complaint-modal.component.html",
  styleUrls: ["./complaint-modal.component.scss"],
})
export class ComplaintModalComponent implements OnInit {
  ngUnsubscribe = new Subject<void>();
  agentId = "";
  agents: any[] = [];

  complaintForm = new FormGroup<any>({
    platform: new FormControl(null, [Validators.required]),
    priority: new FormControl(null, [Validators.required]),
    complaint: new FormControl(null, [Validators.required]),
    rating: new FormControl(null),
    assigned: new FormControl(null),
  });

  constructor(
    public dialogRef: MatDialogRef<ComplaintModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private customerDashboardService: CustomerDashboardService,
    private storageService: StorageService,
    private activateRoute: ActivatedRoute,
    public commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.agentId = this.storageService.getUser()?.userId;
    this.getAgents();
  }

  getAgents() {
    this.customerDashboardService.getAgent$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((agents) => {
        if (agents?.length) {
          this.agents = agents;
        }
      });
  }

  close() {
    this.dialogRef.close();
  }

  handleSaveComplaint() {
    if (this.complaintForm.invalid) {
      this.complaintForm.markAllAsTouched();
      return;
    }
    const payload = {
      postedBy: this.agentId,
      userId: this.data?.userId,
      assigned: this.complaintForm.get("assigned").value,
      agentId: this.agentId,
      claimId: this.data?.claimId || null,
      rating: this.complaintForm.get("rating").value,
      status: "New",
      priority: this.complaintForm.get("priority").value,
      complaint: this.complaintForm.get("complaint").value,
      platform: this.complaintForm.get("platform").value,
    };
    if(this.data?.agreementNumber) Object.assign(payload,{agreementNumber:this.data?.agreementNumber });
  
    this.customerDashboardService.setFetchFeedback(false);
    this.apiService
      .post(
        endpoints.customerDashboard.saveComplaint,
        payload
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: any) => {
          this.apiService.alert(res.body.message, ErrorType.Success);
          this.customerDashboardService.setFetchFeedback(true);
          this.close();
        },
        (err) => {
          this.apiService.alert(err.message, ErrorType.Error);
        }
      );
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
